export const queryKeys = {
  getLookupValues: "getLookupValues",
  getStates: "getStates",
  getState: "getState",
};

export const regionLookupId = "21107ba1-6255-ed11-9de2-00155d112818";
